import fetch, { RequestInfo, RequestInit, Response } from 'node-fetch'

export function customFetch(url: RequestInfo, init?: RequestInit): Promise<Response> {
  if (!init) {
    init = {}
  }

  init.headers = {
    ...init.headers,
    'X-IS24-Insertion-Agent': 'central-listing',
  }
  return fetch(url, init)
}

export function isAbortedError(error: unknown): boolean {
  return (
    error instanceof Error &&
    error.name === 'TypeError' &&
    (error.message === 'Failed to fetch' || error.message === 'Load failed')
  )
}

export default customFetch
